var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTrash(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 22.96,
    height: 24.389,
    viewBox: "0 0 22.96 24.389",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:#78849e;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M159.433,152.163v16.285a3.343,3.343,0,0,1-3.318,3.319H144.846a3.294,3.294,0,0,1-3.318-3.319V152.163h-1.776a.772.772,0,0,1,0-1.543h5.4v-.85a2.4,2.4,0,0,1,2.393-2.393h5.866a2.4,2.4,0,0,1,2.393,2.393v.85h5.4a.772.772,0,0,1,0,1.543ZM146.7,150.62h7.563v-.85a.856.856,0,0,0-.848-.848h-5.866a.856.856,0,0,0-.848.848Zm-3.628,1.543v16.285a1.746,1.746,0,0,0,1.775,1.775h11.269a1.8,1.8,0,0,0,1.775-1.775V152.163Z",
    transform: "translate(-139 -147.378)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M145.5,155.206a.772.772,0,0,1,1.544,0v9.8a.772.772,0,0,1-1.544,0Z",
    transform: "translate(-138.037 -146.331)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M151.151,155.206a.772.772,0,0,1,1.544,0v9.8a.772.772,0,0,1-1.544,0Z",
    transform: "translate(-137.202 -146.331)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M148.328,155.206a.772.772,0,0,1,1.543,0v9.8a.772.772,0,0,1-1.543,0Z",
    transform: "translate(-137.619 -146.331)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTrash);
export default __webpack_public_path__ + "static/media/trash.2e95423175ae0dc544d279107d7953e1.svg";
export { ForwardRef as ReactComponent };